import { render, staticRenderFns } from "./PageButton.vue?vue&type=template&id=3c77cedd"
import script from "./PageButton.vue?vue&type=script&lang=js"
export * from "./PageButton.vue?vue&type=script&lang=js"
import style0 from "./PageButton.vue?vue&type=style&index=0&id=3c77cedd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports